import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipCategoriesControllerModule } from './controllers/MembershipCategoriesController';
import { MembershipCategoriesCreateView } from './create/create';

export const MembershipCategoriesView = angular
  .module('acme.view.application.membership.categories', [
    uiRouter,
    'ui.bootstrap',
    MembershipCategoriesCreateView,
    MembershipCategoriesControllerModule,
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const membershipCategories = {
      name: 'application.membership.categories',
      url: '/categories',
      views: {
        'subview-main': {
          controller: 'MembershipCategoriesController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/categories/categories.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Levels',
        permissions: ['MEMBERSHIP_CATEGORY_VIEW'],
        enablePreferences: true,
      },
    };

    $stateProvider.state(membershipCategories);
  }).name;
